import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { IPaginationParams } from '@interfaces';
import { ApiResponse } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class NirlatGiftOrdersService {
  constructor(private http: HttpClient) {}
  getAllNirlatGiftOrders(params: IPaginationParams) {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    params?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>('/v1/admin/nirlat-gift-orders', { params: httpParams });
  }
  getNirlatGiftOrderById(id: string) {
    return this.http.get<ApiResponse>(`/v1/admin/nirlat-gift-orders/${id}`);
  }
  updateNirlatGiftOrder(id: string, orderData: any) {
    return this.http.put<ApiResponse>(`/v1/admin/nirlat-gift-orders/${id}`, orderData);
  }
  exportNirlatGiftOrders(filterData: IPaginationParams & { giftId?: string | null }) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '')
      .set('userId', filterData.userId ? filterData.userId : '')
      .set('giftId', filterData.giftId ? filterData.giftId : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`/v1/admin/nirlat-gift-orders/export`, filterData, options);
  }
}
